



















































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import vueformmodel from '../../../lib/vueformmodel';
import { FormItem } from 'view-design';
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.ChannelDto = new proxy.ChannelDto();
    ctypes: any[] = [];
    apitypes: any[] = [];
    agents: any[] = []
    // autotimes = []
    //channelTypes = []
    suppliers = []
    isToday = true;
    todayStatistics = new proxy.ChannelStatisticsDto();
    yesterdayStatistics = new proxy.ChannelStatisticsDto();
    disabled = false
    isRequest = false
    tabValue = "detail"
    isClickTab = false
    get prox() {
        return new proxy.ChannelServiceProxy();
    }
    yueRecordPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.ChannelBalanceLogPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '类型',
                key: 'balanceTypeName'
            },
            {
                title: "变动前",
                key: "balance",
            },
            {
                title: "变动",
                key: "money",
            },
            {
                title: "变动后",
                key: "afterBalance",
            },
            {
                title: "变动说明",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };
    yuetzPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.ChannelBalanceAdjustOrderPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '调整单号',
                key: 'orderNo'
            },
            {
                title: "调整金额",
                key: "money",
            },
            {
                title: "调整原因",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };
    yufutzPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.ChannelAdvanceMoneyAdjustOrderPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '调整单号',
                key: 'orderNo'
            },
            {
                title: "调整金额",
                key: "money",
            },
            {
                title: "调整原因",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };
    pagesizeChange(data, page, t) {
        data.pageSize = page;
        switch (t) {
            case 1:
                this.yueRecordPageNumberChange(data.pageNumber);
                break;
            case 2:
                this.yuetzPageNumberChange(data.pageNumber);
                break;
            case 3:
                this.yufutzPageNumberChange(data.pageNumber);
                break;
        }
    }
    yueRecordPageNumberChange(page: number) {
        this.yueRecordPage.isTableLoading = true;
        this.yueRecordPage.input.maxResultCount = this.yueRecordPage.pageSize;
        this.yueRecordPage.input.skipCount = (page - 1) * this.yueRecordPage.pageSize;
        this.yueRecordPage.input.channelId = this.id || 0;
        new proxy.ChannelBalanceLogServiceProxy().queryModelList(this.yueRecordPage.input).then((x) => {
            this.yueRecordPage.isTableLoading = false;
            this.yueRecordPage.dataList = x.items;
            this.yueRecordPage.totalItems = x.totalCount;
            this.yueRecordPage.totalPages = Math.ceil(
                x.totalCount / this.yueRecordPage.pageSize
            );
        });
    }
    yuetzPageNumberChange(page: number) {
        this.yuetzPage.isTableLoading = true;
        this.yuetzPage.input.maxResultCount = this.yuetzPage.pageSize;
        this.yuetzPage.input.skipCount = (page - 1) * this.yuetzPage.pageSize;
        this.yuetzPage.input.channelId = this.id || 0;
        new proxy.ChannelBalanceAdjustOrderServiceProxy().queryModelList(this.yuetzPage.input).then((x) => {
            this.yuetzPage.isTableLoading = false;
            this.yuetzPage.dataList = x.items;
            this.yuetzPage.totalItems = x.totalCount;
            this.yuetzPage.totalPages = Math.ceil(
                x.totalCount / this.yuetzPage.pageSize
            );
        });
    }
    yufutzPageNumberChange(page: number) {
        this.yufutzPage.isTableLoading = true;
        this.yufutzPage.input.maxResultCount = this.yufutzPage.pageSize;
        this.yufutzPage.input.skipCount = (page - 1) * this.yufutzPage.pageSize;
        this.yufutzPage.input.channelId = this.id || 0;
        new proxy.ChannelAdvanceMoneyAdjustOrderServiceProxy().queryModelList(this.yufutzPage.input).then((x) => {
            this.yufutzPage.isTableLoading = false;
            this.yufutzPage.dataList = x.items;
            this.yufutzPage.totalItems = x.totalCount;
            this.yufutzPage.totalPages = Math.ceil(
                x.totalCount / this.yufutzPage.pageSize
            );
        });
    }
    agentIdchange(e) {
        if (e) {
            this.model.agentName = this.agents.find(x => x.id == e).name;
        } else {
            this.model.agentName = '';
        }
    }
    //产品绑定
    // bindChannelTypes() {
    //     let req = new proxy.ChannelBindChannelTypeDto();
    //     req.channelId = this.id;
    //     var ss = [];
    //     this.channelTypes.map(x => {
    //         if (x.check == true) {
    //             ss.push(x.id);
    //         }
    //     });
    //     req.channelTypeIds = ss;
    //     this.prox.bindChannelType(req).then(x => {

    //     });
    // }
    save() {
        if (this.isRequest) {
            return;
        }
        // this.model.openTime = this.autotimes[0];
        // this.model.closeTime = this.autotimes[1];
        this.isRequest = true;
        (this.$refs.roleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.prox.createOrUpdate(this.model).then(() => {
                    // this.bindChannelTypes();
                    (this.$refs.roleForm as any).resetFields();
                    this.todayStatistics = new proxy.ChannelStatisticsDto();
                    this.yesterdayStatistics = new proxy.ChannelStatisticsDto();
                    this.$Notice.success({ title: '保存成功' });
                    this.$emit('save-success');
                    this.$emit('input', false);
                }).finally(() => {
                    this.isRequest = false;
                });
            }
        });
    }
    //查出已绑定产品
    // channelTypeMethod() {
    //     var input = new proxy.ChannelTypePageInputDto();
    //     input.skipCount = 0;
    //     input.maxResultCount = 999;
    //     new proxy.ChannelTypeServiceProxy().queryModelList(input).then(x => {
    //         this.channelTypes = x.items;
    //         this.channelTypes.map(c => {
    //             c.check = false;
    //         });
    //         new proxy.ChannelTypeServiceProxy()
    //             .queryChannelTypesByChannelId(this.id).then(d => {
    //                 this.channelTypes.map(b => {
    //                     var ss = d.findIndex(j => j.id == b.id);
    //                     if (ss != -1) {
    //                         b.check = true;
    //                     }
    //                 })
    //                 this.$forceUpdate();
    //             });
    //     });
    // }
    statisticsClick(num) {
        if (num) {
            if (this.yesterdayStatistics) {
                this.isToday = false
            } else {
                this.$Notice.info({ title: '暂无昨日数据' })
            }
        } else {
            this.isToday = true
        }
    }

    confirm() {
        this.$Modal.confirm({
            title: '同步同类型通道配置',
            content: '确认后将相同供应商统一更改配置',
            onOk: () => {
                this.prox.synchronousUpdate(this.model).then(x => {
                    this.$Notice.success({ title: '同步成功！' });
                    this.$emit('input', false);
                });
            },
        });
    }

    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.todayStatistics = new proxy.ChannelStatisticsDto();
        this.yesterdayStatistics = new proxy.ChannelStatisticsDto();
        this.tabValue = "detail"
        this.isClickTab = false
        this.$emit('input', false);
    }

    tabClick(name) {
        if(name == "statistics") {
            if(!this.isClickTab) {
                this.todayStatistics.totalAmount = 0;
                this.todayStatistics.successAmount = 0;
                this.todayStatistics.channelRateCommission = 0;
                this.todayStatistics.totalOrderNum = 0;
                this.todayStatistics.successOrderNum = 0;
                this.todayStatistics.successRate = 0;
                var reqSearch = new proxy.QueryChannelTotalPageInputDto();
                reqSearch.channelId = !this.id ? 0 : this.id;
                reqSearch.createTime = new Date(new Date(new Date().toLocaleDateString()).getTime());
                reqSearch.endTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
                new proxy.FinanceManageServiceProxy().queryChannelTotal(reqSearch).then((x) => {
                    if(x.length > 0){
                        this.todayStatistics = x[0];
                    }
                });
                reqSearch.createTime = new Date(new Date(new Date().toLocaleDateString()).getTime() - 86400000);
                reqSearch.endTime = new Date(new Date(new Date().toLocaleDateString()).getTime());
                new proxy.FinanceManageServiceProxy().queryChannelTotal(reqSearch).then(x => {
                    this.yesterdayStatistics = x[0];
                })
                this.isClickTab = true
            }
        }
    }

    visibleChange(value: boolean) {
        if (!value) {
            this.todayStatistics = new proxy.ChannelStatisticsDto();
            this.yesterdayStatistics = new proxy.ChannelStatisticsDto();
            this.tabValue = "detail"
            this.isClickTab = false
            this.$emit('input', value);
        } else {
            this.disabled = true
            let req = new proxy.ChannelTypePageInputDto();
            req.maxResultCount = 500;
            new proxy.ChannelTypeServiceProxy().queryModelList(req).then(x => {
                this.ctypes = x.items;
                this.prox.queryModel(this.id).then(x => {
                    this.model = x;
                    this.disabled = false
                    this.yueRecordPageNumberChange(1);
                    this.yuetzPageNumberChange(1);
                    this.yufutzPageNumberChange(1);
                    // this.model.openTime = this.model.openTime || '';
                    // this.model.closeTime = this.model.closeTime || ''
                    // this.autotimes = [this.model.openTime || '', this.model.closeTime || ''];
                });
            })
            // new proxy.CommonServiceProxy().getEnumKeyValue('ChannelApiTypeEnum').then(x => {
            //     this.apitypes = x;
            //     this.$forceUpdate();
            // })

            // let req2 = new proxy.AgentPageInputDto();
            // req2.status = 0;
            // req2.maxResultCount = 100;
            this.prox.queryAgentList().then(x => {
                this.agents = x;
            })

            new proxy.ChannelSupplierServiceProxy().queryAllList().then(x => {
                this.suppliers = x;
            })


            //this.channelTypeMethod();
        }
    }

    roleRule = {
        suppName: [
            {
                required: true,
                message: this.L('FieldIsRequired'),
                trigger: 'blur'
            }
        ]
    };
}
